module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAABRUlEQVRIS7XUvy8DYRzH8ffT0kQQMVVo7mGS1MDUf4CFjb8Ak8QksUisBjFJDET02mJoWUj9Q/4G7SD0I3fpSVHtXT1uvB/v1z133zwGyXhljhAH/MNhoqb1tS04B4ZdOp9AEPWKWsFwD0y4Qr4AIVLSAuIJsC6QH0AQnfU11YIHoNCJPG+Zrvd3exHPl4Lzvz6QrWg088a1MaxHAadAGK0pbZucSOwN+rliLdmWtCtxCqSTQrGAIGp9rclQRYwlQWID7Z+/1CKcsOm4SCIgiM5cKpcaom5gMQ6SGAii81cabxqqxrDaDxkIiCbMa3AG7PRCBgfaVVvUvgzHQKob9GegPWEbghtg5DviBAiiubIKqRaPQLYTcQaEK6loTu/UgXyEOAXC3fhWk7xyByz33Oz6jV+v6/maMi8NLoBN5yvohG1Rhx9OYVYu8CiNEAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Alert/image/Alert_minus.png
// module id = SNSo
// module chunks = 240